export const renderMeta = ([name, content]: [string, string]) => {
  const isOg = name.startsWith("og:");
  return isOg ? (
    <meta key={name} property={name} content={content} />
  ) : (
    <meta key={name} name={name} content={content} />
  );
};
